import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { isTV } from "../../../utils/platform";

const DOC_FONT_SIZE = isTV ? 18 : 12;

export const useStyles = createUseStyles((theme: ITheme) => ({
  focused: {},
  legalContent: {
    width: "100%",
    height: "100%",
    outline: "none",
  },
  legalDoc: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
    outline: "none",
    boxSizing: "border-box",
    padding: "0 16px 24px 0",
    color: "#C0C0C0",
    fontSize: DOC_FONT_SIZE,
    lineHeight: "140%",
    fontFamily: "Poppins",
    "& p": {
      margin: "0 0 16px",
    },
    "& strong": {
      fontWeight: 600,
    },
    "& a": {
      color: "#C0C0C0",
      wordBreak: "break-word",
    },
    "& ol, & ul": {
      paddingLeft: 24,
      margin: "0 0 16px",
    },
    "& li": {
      margin: "0 0 8px",
    },
    "& table": {
      width: "100%",
      borderCollapse: "collapse",
      tableLayout: "fixed",
      margin: "0 0 16px",
    },
    "& th, & td": {
      border: "1px solid #3A3A3A",
      padding: 8,
      verticalAlign: "top",
      textAlign: "left",
      wordBreak: "break-word",
    },
    "& th": {
      fontWeight: 600,
    },
    "& td ol, & td ul, & td p": {
      margin: 0,
    },
    '& col[class~="w-[7%]"]': { width: "7%" },
    '& col[class~="w-[20%]"]': { width: "20%" },
    '& col[class~="w-[48%]"]': { width: "48%" },
    '& col[class~="w-[23%]"]': { width: "23%" },
    "&::-webkit-scrollbar": {
      width: 20,
      borderRadius: 50,
      background: "#1B1B1B",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#C1C1C1",
      backgroundClip: "padding-box",
      borderRadius: 50,
      border: "6px solid transparent",
    },
    "&$focused::-webkit-scrollbar-thumb": {
      outline: "3px solid #C1C1C1",
      outlineOffset: -3.5,
    },
    "@media (pointer: coarse)": {
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  qrContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  qrLink: {
    marginTop: theme.spacing.space12,
    textDecoration: "underline",
    wordBreak: "break-all",
  },

  qrCode: {
    display: "block",
    width: "240px !important",
    height: "240px !important",
    borderRadius: theme.radius.large,
  },
}));
